import React from 'react';

import type { Apollo } from 'src/gql/generated';
import type { WorkflowStep } from 'src/workflow';
import { ManageRecipientsSection } from 'src/workflow';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  root: {
    maxWidth: 1000,
  },
}));

type WorkflowStepsWorkflow = Pick<
  Apollo.Workflow,
  'id' | 'isSignedOutsideAline' | '__typename' | 'state'
>;

interface WorkflowStepsProps {
  activeStep: WorkflowStep | null;
  orderedSteps: WorkflowStep[];
  workflow: WorkflowStepsWorkflow;
  showProgress?: boolean;
}

export function WorkflowSteps({
  activeStep,
  orderedSteps,
  showProgress = true,
  workflow,
}: WorkflowStepsProps) {
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <ManageRecipientsSection
        activeStep={activeStep}
        orderedSteps={orderedSteps}
        showProgress={showProgress}
        workflow={workflow}
      />
    </div>
  );
}
